export const orderModule = {
    cancel: "キャンセル",
    pay: "会計",
    chose_pay_type:"お支払い方法をご選択ください",
    phone:"携帯番号",
    desc1:"下記の携帯番号或はEmailにチケットURLを送信されます",
    pay_title:"お支払い",
    to_pay:"お会計へ進む",
    agree:"に同意する",
    policy:"プライバシーポリシー",
    total:"合計",
    use_point:"利用スポット",
    use_point_code:"ご利用時QRコード",
    code:"照合コード",
    used_point:"利用済スポット",
    more:"もっと見る",
    input:"必要情報をご記入ください",
    pay_type:"お支払い方法を選択してください",
    isCancel:"キャンセルしますか?",
    sure:"確定",
    pay_success:"ご購入ありがとうございました",
    pay_cancel:"キャンセルしました",
    pay_fail:"支払いに失敗します",
    pay_cancel1:"キャンセルしました",
    pay_wait:"支払い結果待ちです。",
    status1:"支払待ち",
    status2:"利用可",
    status3:"使用済",
    status4:"期限切れです",
    status5:"返金済",
    status6:"キャンセル",
    selectBookFun: "選択の仕方です",
    inputBookPlaceholder: "領収書の宛名",
    inputMemoPlaceholder: '備考（〇〇代として）',
    getBook: "領収書発行",
    comment: "レビュー",
    comment_star: "満足度",
    comment_contentHolder: "コメントをどうぞご入力ください",
    comment_noStar: "満足度をご選択ください",
    comment_noContent: "どうぞコメントしてくださいコメントする",
    comment_submitSuccess: "コメントしました",
    comment_replay: "店舗回答",
    comment_uploadSuccess: "アップロードしました",
    comment_moreImg: "最大4枚の画像をアップロードしてください。",
    comment_sizeImg: "画像は5M以上ではいけません。",
};

export default orderModule;